import React, { FC } from 'react';
import { Platform } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';

import { Box } from '@fhs-legacy/universal-components';
import { STORE_LOCATOR_CONTAINER } from 'utils/test-ids';

import { ItemsUnavailableDialog } from './items-unavailable-dialog';
import { StoreLocatorProvider } from './store-locator-provider';
import { StoreLocatorView } from './store-locator.view';

/**
 *
 * StoreLocator purpose
 *
 */
const StoreLocator: FC<React.PropsWithChildren<unknown>> = () => {
  return (
    <StoreLocatorProvider>
      <SafeAreaView edges={Platform.OS === 'android' ? ['bottom'] : []} style={{ flex: 1 }}>
        <Box flex={1} testID={STORE_LOCATOR_CONTAINER}>
          <StoreLocatorView />
          <ItemsUnavailableDialog />
        </Box>
      </SafeAreaView>
    </StoreLocatorProvider>
  );
};

export default StoreLocator;
